import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Input, OnInit, Optional, Output, ViewChild } from '@angular/core';
import { FormGroup, FormArray, FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { Mode, MatDialogCloseEvent, DocumentType, PageKey } from '../../const';
import { DtoClientAccount, Pagination, Document, UserRoles } from '../../models/mat-account.model';
import { DtoSchool, DtoSchoolAdmin, DtoSchoolUser } from '../../models/school.model';
import { Users } from '../../models/user-center.model';
import { ConfirmComponent } from '../../shared/components/confirm/confirm.component';
import { SharedService } from '../../shared/services/shared.service';
import { HelperMethods } from '../common/helper-methods.service';
import { ConfirmDialogComponent } from '../mat-account/confirm-dialog/confirm-dialog.component';
import { MatAccountComponent } from '../mat-account/mat-account.component';
import { MatAccountService } from '../mat-account/mat-account.service';
import { Tabs } from '../package-center/package-center.component';
import { SchoolService } from '../school/school.service';
import { RoleMaster } from '../user-center/user-role/user-role.component';
import { Role, RolePayload } from '../../models/role.model';
import { SendBulkEmailComponent } from '../mat-account/send-bulk-email/send-bulk-email.component';
import { PackageService } from '../package-center/package/package.service';
import { SearchService } from '../common/search.service';
interface UploadFileList {
  id: string | null;
  files: File[];
}

@Component({
  selector: 'app-independent-school',
  templateUrl: './independent-school.component.html'
})
export class IndependentSchoolComponent implements OnInit, OnInit {
  @Input() buttonTitle: string = 'Upload from Device';
  @Output() fileChange = new EventEmitter<FileList>();
  @ViewChild('fileInput') fileInput: ElementRef | undefined;

  private schoolFormSubscription: Subscription | undefined;
  subscription: Subscription = new Subscription();
  currentStep: number = 0; // Property to define the current step in independent school creation
  steps = Steps; // Enum to define the total number of steps
  createIndividualSchoolForm: boolean = false; // Property to define whether to show/hide the back/cancel/next button
  packageToAssign: number = 0; // Property to define whether the package is assigned
  showForm: boolean = false; //Property to define whether 'Create Package' is triggered
  openedPackage: boolean = false; //Property to define whether 'Create Package/Edit Package' is triggered
  isOffcanvasVisible:boolean = false;
  schoolToEdit: DtoSchool = {} as DtoSchool;
  activeTab: string = Tabs.Package;
  accountAdminList: Users[] = [];
  schoolList: DtoSchool[] = [];
  phoneNumberUtil = PhoneNumberUtil.getInstance();
  role = RoleMaster;
  userRole: string[] = [];
  roleName: string[] = [];
  searchTerm : string ="";
  pageKey = PageKey.IndependentSchoolCenter;
  isEdit: boolean = false;
  totalRecords: number = 0;
  pagination: Pagination = {
    searchTerm: "",
    pageOffset: 0,
    pageSize: 10,
    sortColumn: "",
    sortDirection: "",
    userRole: [] as string[]
  }
  selectedFile: File | null = null;
  schoolUploadFileList: File[] = [];  
  userEmail: string = "";
  schoolDetailsForm = this.fb.group({
    schools: this.fb.array([])
  });
  roleForm = new FormGroup({
    roleDetails: new FormArray([]),
  });
  completedProcess: boolean = false;
  createdSchoolDetails: DtoSchool[] = [];
  roles: Role[] = [];
  maxStep: number = 0;
  schoolAccountUploadedFileList: { [index: number]: UploadFileList } = {};
  schoolAdminUploadedFileLists: { [index: number]: UploadFileList } = {};
  schoolUserUploadedFileLists: { [index: string]: UploadFileList } = {};
  partialSave: boolean = false;
  createdSchoolId: (number | null)[] = [];

  constructor(
    private matAccountService: MatAccountService,
    private schoolService: SchoolService,
    private toasterService: ToastrService,
    private router: Router,
    public helperMethods: HelperMethods,
    public dialog: MatDialog,
    @Optional() public dialogRef: MatDialogRef<MatAccountComponent>,
    private sharedService: SharedService,
    private fb: FormBuilder,
    private packageService: PackageService,
    private readonly searchService: SearchService
  ) { }

  ngOnInit(): void {
    this.searchTerm = this.searchService.getSearchTerm(this.pageKey);
    this.userRole = sessionStorage.getItem('user_role')?.split(',')!;
    this.userRole?.forEach(element => {
      this.roleName.push(this.getRoleNameByValue(RoleMaster, element)!);
    });
    this.getIndependentSchools(this.pagination);
    this.subscription.add(this.sharedService.doFileUpload.subscribe((data) => {
      this.uploadFromLocal(data, true);
    }));

    this.subscription.add(this.sharedService.showFilePreview.subscribe((data) => {
      this.previewFile(data);
    }));

    this.userEmail = sessionStorage.getItem('user_email')!;
    this.schoolFormSubscription = this.sharedService.schoolFormValidity.subscribe(schoolForm => {
      this.schoolDetailsForm = schoolForm;
    });

    this.sharedService.roleFormValidity.subscribe(roleForm => {
      this.roleForm = roleForm;
    });
    this.getAccountAdminDetails();
  }

  getRoleNameByValue<T extends { [index: string]: string }>(
    enumObj: T,
    value: string
  ): string | undefined {
    const keys = Object.keys(enumObj).filter((x) => enumObj[x] === value);
    return keys.length > 0 ? keys[0] : undefined;
  }

  getAccountAdminDetails() {
    let payload: UserRoles = {} as UserRoles;
    payload.userRole = this.userRole;
    this.matAccountService.getAccountAdminDetails(this.userRole).subscribe((response: Users[] | any) => {
      this.accountAdminList = response;
    }, (err: HttpErrorResponse) => {
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    });
  }
  
  resetCreateIndependentSchoolCreationProcess(){
    this.createIndividualSchoolForm = false; 
    this.currentStep = 0; 
    this.maxStep = this.currentStep;
    this.packageToAssign = 0;
    this.showForm = false;
    this.isEdit = false;
    this.completedProcess = false;
    this.partialSave = false;
    this.createdSchoolDetails = [];
    this.resetSchoolForm();
    this.resetRoleForm();
  }

  onCreateIndependentSchool(){
    this.createIndividualSchoolForm = true;
    this.currentStep = this.steps.AssignPackage;
    this.maxStep = this.currentStep > this.maxStep ? this.currentStep : this.maxStep;
    this.schoolUploadFileList = [];
    this.resetSchoolForm();
    this.resetRoleForm();
  }

  getIndependentSchools(payload: Pagination) {
    this.searchService.setSearchTerm(this.pageKey, this.searchTerm);
    payload.userRole = this.userRole;
    payload.searchTerm = this.searchTerm.trim();
    this.schoolService.getIndependentSchools(payload).subscribe((response: DtoSchool[]) => {
      this.schoolList = response;
      this.totalRecords = response.length ? response[0].totalRecords : 0;
      this.resetCreateIndependentSchoolCreationProcess()
    },(error: HttpErrorResponse)=>{
      if(error.error){
        this.toasterService.error(error.error, "Error");
      }
    })
  }

  previewFile(file: Document) {
    let link = document.createElement("a");
    if (link.download !== undefined) {
      let blob = new Blob([file.fileData!], { type: file.filePath });
      let url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", file.fileName);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  showPackageList() {
    this.currentStep = this.steps.AssignPackage;
    this.maxStep = this.currentStep > this.maxStep ? this.currentStep : this.maxStep;
  }

  receivedPackage(packageId: number) {
    this.packageToAssign = packageId;
  }

  hideNavigationButtons(value: boolean) {
    //Value == false : Edit Package is triggered
    if (value) {
      this.showForm = false;
    }
    this.currentStep = value
      ? this.steps.AssignPackage
      : this.steps.EditPackage;
      this.maxStep = this.currentStep > this.maxStep ? this.currentStep : this.maxStep;
      this.createIndividualSchoolForm = value;
    this.openedPackage = !this.createIndividualSchoolForm;
  }

  setValueForIsEdit(currentStep: number, checkForFormValidity: boolean = false): boolean{
    if(currentStep == this.steps.AddSchool || currentStep == this.steps.CreateRole){
      if(currentStep == this.steps.AddSchool && checkForFormValidity){
        return this.isFormValidExceptSchoolUsers();
      }
      return this.createdSchoolDetails && this.createdSchoolDetails.length > 0 && this.createdSchoolDetails[0].schoolId! > 0;
    }
    else{
      return false;
    }
  }

  goToSelectedStep(stepToChange: number) {
    if(stepToChange <= this.maxStep){
      this.currentStep = stepToChange;
      this.maxStep = this.currentStep > this.maxStep ? this.currentStep : this.maxStep;
      this.isEdit = this.setValueForIsEdit(this.currentStep, true);
    }
  }

  disableNext(currentStep: number) {
    switch(currentStep){
      case this.steps.AssignPackage:
        if(this.packageToAssign == 0){
          this.toasterService.warning("Please select a package to proceed");
          return false;
        }
        else{
          return true;
        }
      case this.steps.CreateRole:
        if(this.roleForm.invalid || this.roleForm.untouched){
          this.roleForm.markAllAsTouched();
          this.toasterService.warning("Please fill the required fields to proceed");
          return false;
        }
        else{
          return true;
        }
      case this.steps.AddSchool:
        if(!this.isFormValidExceptSchoolUsers()){
          this.schoolDetailsForm.markAllAsTouched();
          this.toasterService.warning("Please fill the required fields to proceed");
          return false;
        }
        else{
          return true;
        }
      case this.steps.CreateUser:
        if(this.schoolDetailsForm.invalid || this.schoolDetailsForm.untouched){
          this.schoolDetailsForm.markAllAsTouched();
          this.toasterService.warning("Please fill the required fields to proceed");
          return false;
        }
        else{
          return true;
        }
      default:
        return true;
    }
  }

  async triggerAction(){
    if(!this.disableNext(this.currentStep)){
      return;
    }

    let matAccountDetails = {} as DtoClientAccount;
    this.isEdit = this.setValueForIsEdit(this.currentStep);

    if(this.currentStep == this.steps.AddSchool || this.currentStep == this.steps.CreateRole){ 
      matAccountDetails.schools = JSON.parse(JSON.stringify(this.schoolDetailsForm.controls['schools'].value));
      let validateOn: string = "";

      if(this.currentStep == this.steps.AddSchool){
        for(const element of matAccountDetails.schools) {
          let school: any = element;
          if(!school.assignedAccountAdmin?.userId || school.assignedAccountAdmin?.userId <= 0){
            this.toasterService.error("Please assign an account admin for the school!");
            return;
          }
        }
        validateOn = "school";
      }
      else if(this.currentStep == this.steps.CreateRole){
        validateOn = "role";
        matAccountDetails.schools = JSON.parse(JSON.stringify(this.schoolDetailsForm.controls['schools'].value));
        for(const element of matAccountDetails.schools) {
          let school: any = element;
          school.role = this.roleForm.value.roleDetails;
        }
      }
      const isValid = await this.validateJson(matAccountDetails.schools, matAccountDetails, validateOn)
        if(!isValid){
          return;
        }
    }

    if(this.packageToAssign > 0 && this.currentStep != this.steps.AddSchool && this.currentStep != this.steps.CreateUser && this.currentStep != this.steps.CreateRole){
      this.currentStep = this.steps.AddSchool;
      this.maxStep = this.currentStep > this.maxStep ? this.currentStep : this.maxStep;
    }
    else if(this.currentStep == this.steps.AddSchool){
      if(this.partialSave){
        this.createIndividualSchools();
        return;
      }
      this.currentStep = this.steps.CreateRole;
      this.maxStep = this.currentStep > this.maxStep ? this.currentStep : this.maxStep;
    }
    else if(this.currentStep == this.steps.CreateRole){
      this.roleForm.value.roleDetails!.forEach((element: any) => {
        element.IsIndividualEntity = true ;
      });
      this.createIndividualSchools();
    }
    else if(this.currentStep == this.steps.CreateUser){
      this.createSchoolUsers();
    }
    else if(this.currentStep == this.steps.AssignPackage){
      this.showPackageList();
    }
    else{
      this.roleForm.markAllAsTouched();
      this.schoolDetailsForm.markAllAsTouched();
      this.toasterService.warning("Please fill the required fields to proceed");
    }
  }

  isFormValidExceptSchoolUsers(): boolean {
    const schools = this.schoolDetailsForm.get('schools') as FormArray;

    if(!schools){
      return true;
    }

    // Temporarily disable all schoolUsers controls
    schools.controls.forEach(school => {
      const schoolUsers = school.get('schoolUsers') as FormArray;
      schoolUsers.disable({ emitEvent: false });
    });

    // Check form validity
    const isValid = this.schoolDetailsForm.valid;

    // Re-enable all schoolUsers controls
    schools.controls.forEach(school => {
      const schoolUsers = school.get('schoolUsers') as FormArray;
      schoolUsers.enable({ emitEvent: false });
    });

    return isValid;
  }  

  handleBack(){
    if(this.currentStep == this.steps.CreateRole){
      this.currentStep = this.steps.AddSchool;
    }
    else if(this.currentStep == this.steps.AddSchool){
      this.currentStep = this.steps.AssignPackage;
    }
    else if(this.currentStep == this.steps.CreateUser){
      this.currentStep = this.steps.CreateRole;
    }
    this.maxStep = this.currentStep > this.maxStep ? this.currentStep : this.maxStep;
    this.isEdit = this.setValueForIsEdit(this.currentStep, true);
  }

  async validateJson(schools: any, matAccountDetails: any, validateOn: string): Promise<boolean> {
    if(this.isFormValidExceptSchoolUsers() || this.schoolDetailsForm.controls['schools']?.valid){
      if(this.hasDuplicates(schools.map((x: any)=> x.schoolName))){
        this.toasterService.warning("School names must be unique");
        return false;
      }

      let emails = schools.filter((x: DtoSchool) => x.schoolAdmin && 'emailId' in x.schoolAdmin && x.schoolAdmin.emailId?.trim()).map((x: DtoSchool) => x.schoolAdmin?.emailId?.trim());
      if(this.hasDuplicates(emails)){
        this.toasterService.warning("Email address of school admin(s) must be unique");
        return false;
      }

      if(this.roleForm.valid && this.roleForm.value.roleDetails){
        if(this.hasDuplicates(this.roleForm.value.roleDetails.map((x: any)=> x.roleName))){
          this.toasterService.warning("Audience types must be unique");
          return false;
        }
      }
  
      let schoolUserEmails: string[] = [];
      for(const element of schools) {
        let school = element;
        school.schoolId = school.schoolId ?? 0;
        school.schoolAdmin.schoolAdminId = school.schoolAdmin.schoolAdminId ?? 0;
        school.schoolAdmin.schoolId = school.schoolAdmin.schoolId ?? 0;
        school.assignedAccountAdmin = school.assignedAccountAdmin?.userId;
        for(const element of school.schoolUsers) {
          let user = element;
          user.schoolUserId = user.schoolUserId ?? 0;
          user.schoolId = school.schoolId ?? 0;
          if(user.emailId){
            schoolUserEmails.push(user.emailId);
          }
        }
      }
  
      if(this.hasDuplicates(schoolUserEmails)){
        this.toasterService.warning("Email address of school user(s) must be unique");
        return false;
      } 
    }
    try {
      matAccountDetails.validateOn = validateOn;
      matAccountDetails.isUpdate = this.isEdit;
      const response = await this.matAccountService.validateMatAccount(matAccountDetails);
      if (response.isSuccess) {
        return true;
      } else {
        return false;
      }
    } catch (errorResponse: any) {
      this.toasterService.error(errorResponse.error, (errorResponse.status==422?'Validation Error':'Error'));
      return false;
    }
  }
  async createIndividualSchools(): Promise<any> {

    let form = this.schoolDetailsForm.controls['schools'].value;

    let schoolId: any = 0;
    form.forEach((school: any, index: number) => {
      const schoolName = school.schoolName;
      const adminEmailId = school.schoolAdmin?.emailId;
      schoolId = this.createdSchoolDetails.find(x=>x.schoolName == schoolName)?.schoolId;
    
      if (school.schoolAccountUploadFileList) {
        if (!this.schoolAccountUploadedFileList[index]) {
          this.schoolAccountUploadedFileList[index] = { id: null, files: [] };
        }
        const files = school.schoolAccountUploadFileList as File[];
        this.schoolAccountUploadedFileList[index].files = files;
        this.schoolAccountUploadedFileList[index].id = schoolName;
      }
    
      if (school.schoolAdminUploadFileLists) {
        if (!this.schoolAdminUploadedFileLists[index]) {
          this.schoolAdminUploadedFileLists[index] = { id: null, files: [] };
        }
        const files = school.schoolAdminUploadFileLists as File[];
        this.schoolAdminUploadedFileLists[index].files = files;
        this.schoolAdminUploadedFileLists[index].id = adminEmailId;
      }

      school.assignedAccountAdmin = school.assignedAccountAdmin?.userId;
      school.assignedPackageId = this.packageToAssign;
      school.role = this.roleForm.value.roleDetails;
      school.schoolId = schoolId ?? 0;
      school.id = school.id ?? "";
      let schoolAdmin: DtoSchoolAdmin = school.schoolAdmin;
      if(schoolAdmin.emailId && schoolAdmin.firstName && schoolAdmin.lastName && schoolAdmin.contactNumber && schoolAdmin.title){
        schoolAdmin.countryCode = this.phoneNumberUtil.parse(schoolAdmin.contactNumber?.toString()).getCountryCode()!;
        schoolAdmin.phoneNumber = this.phoneNumberUtil.parse(schoolAdmin.contactNumber?.toString()).getNationalNumber()!;
        schoolAdmin.schoolAdminId = schoolAdmin.schoolAdminId ?? 0;
        schoolAdmin.schoolId = schoolId ?? 0;
      }
      else{
        school.schoolAdmin = {} as DtoSchoolAdmin;
      }
      school.schoolUsers = [];
    });

    let schools = JSON.parse(JSON.stringify(form));

    if (this.isEdit) {
      this.schoolService.updateSchool(schools).subscribe((response: any) => {
        if (response) {
          if(this.partialSave){
            this.toasterService.success("School details updated successfully!", "Success");
            this.getIndependentSchools(this.pagination);
            return;
          }
          this.isEdit = false;
          let schoolNames = this.schoolDetailsForm.controls['schools'].value.map((school: any) => school.schoolName);

          this.schoolService.getIndependentSchools(this.pagination).subscribe((data: DtoSchool[] | any)=>{
            this.createdSchoolDetails = data.filter((x: DtoSchool) => schoolNames.includes(x.schoolName));

            this.currentStep = this.steps.CreateUser;
            this.maxStep = this.currentStep > this.maxStep ? this.currentStep : this.maxStep;
            let roleNames = this.roleForm.controls['roleDetails'].value.map((role: Role) => role.roleName);
            this.createdSchoolId = this.createdSchoolDetails.map(x => x.schoolId);
            let payload = {
              isIndividualEntity : true,
              clientAccountId : this.createdSchoolId
            } as RolePayload;
            this.schoolService.getRoles(payload).subscribe((response: Role[] | any)=>{
            //this.schoolService.getRoles(0).subscribe((response: Role[] | any)=>{
              this.roles = response.filter((x: Role) => roleNames.includes(x.roleName));
            },(err: HttpErrorResponse)=>{
              if(err.error){
                this.toasterService.error(err.error, "Error");
              }
            })
          }, (error: HttpErrorResponse)=>{
            if(error.error){
              this.toasterService.error(error.error, "Error");
            }
          })
        }
      }, (errorResponse: HttpErrorResponse) => {
        if(errorResponse.error){
          this.toasterService.error(errorResponse.error, "Error");
        }
      })
    }
    else {
      try {
        //Check if subscription is available for each school's school admin
        let numberOfSubscriptionAvailable = await this.packageService.getAvailableSubscriptionForPackage(this.packageToAssign);
        if(numberOfSubscriptionAvailable < schools.filter((school: DtoSchool)=> school.schoolId == 0 || school.schoolId == undefined || school.schoolId == null).length) {
          this.toasterService.error("Package has exceeded the maximum number of subscriptions");
          return;
        }
      }
      catch (errorResponse: any) {
        this.toasterService.error(errorResponse.error, 'Error');
        return;
      }
      this.schoolService.createSchool(schools, 0).subscribe((response: any) => {
        if (response.isSuccess) {
          this.createdSchoolDetails = response.data;

          this.createdSchoolDetails.forEach((schoolDetail) => {
            // Find the matching school account files by school name
            const matchingSchoolAccountFiles = Object.values(this.schoolAccountUploadedFileList).find(
                item => item.id === schoolDetail.schoolName
            );

            // Find the matching school admin files by admin email ID
            const matchingSchoolAdminFiles = Object.values(this.schoolAdminUploadedFileLists).find(
                item => item.id === schoolDetail.schoolAdmin?.emailId
            );

            if (matchingSchoolAccountFiles && matchingSchoolAccountFiles.files.length > 0) {
              const formData = new FormData();
              matchingSchoolAccountFiles.files.forEach((file) => {
                  formData.append('file', file, file.name);
              });
              this.uploadDocument(formData, DocumentType.School, schoolDetail.entityId!.toString());
            }

            if (matchingSchoolAdminFiles && matchingSchoolAdminFiles.files.length > 0) {
              const formData = new FormData(); 
              matchingSchoolAdminFiles.files.forEach((file) => {                
                formData.append('file', file, file.name);
              });
              this.uploadDocument(formData, DocumentType.EntityAudience, schoolDetail.schoolAdmin?.userId.toString());
            }
          });
          if(this.partialSave){
            this.toasterService.success("School(s) created successfully!", "Success");
            this.getIndependentSchools(this.pagination);
            return;
          }
          this.currentStep = this.steps.CreateUser;
          this.maxStep = this.currentStep > this.maxStep ? this.currentStep : this.maxStep;
          let roleNames = this.roleForm.controls['roleDetails'].value.map((role: Role) => role.roleName);
          this.createdSchoolId = this.createdSchoolDetails.map(x => x.schoolId);
          let payload = {
            isIndividualEntity : true,
            clientAccountId : this.createdSchoolId
          } as RolePayload;
          this.schoolService.getRoles(payload).subscribe((response: Role[] | any)=>{
          //this.schoolService.getRoles(0).subscribe((response: Role[] | any)=>{
            this.roles = response.filter((x: Role) => roleNames.includes(x.roleName));
          },(err: HttpErrorResponse)=>{
            if(err.error){
              this.toasterService.error(err.error, "Error");
            }
          })
        }
      }, (errorResponse: HttpErrorResponse) => {
        if(errorResponse.error){
          this.toasterService.error(errorResponse.error, "Error");
        }
      })
    }
  }

  async createSchoolUsers(): Promise<any> {
    let schools = JSON.parse(JSON.stringify(this.schoolDetailsForm.controls['schools'].value));

    let form = this.schoolDetailsForm.controls['schools'].value;
    form.forEach((school: any, schoolIndex: number) => {
      const schoolUsers = school.schoolUsers;
  
      // Loop through each school user to assign files and get the relevant email ID
      schoolUsers.forEach((schoolUser: any, schoolUserIndex: number) => {
        const emailId = schoolUser.emailId;
        const key = `${schoolIndex}_${schoolUserIndex}`;
  
        if (schoolUser.UploadedFileList) {
          if (!this.schoolUserUploadedFileLists[key]) {
            this.schoolUserUploadedFileLists[key] = { id: null, files: [] };
          }
  
          // Assign files from the form to the schoolUserUploadedFileLists
          const files = schoolUser.UploadedFileList as File[];
          this.schoolUserUploadedFileLists[key].files = files;
          this.schoolUserUploadedFileLists[key].id = emailId;
        }
      });
    });

    let schoolData: DtoSchool[] = [];
    
    for(var i=0; i<schools.length; i++) {
      let school: DtoSchool = schools[i];
      let schoolUsersList = school.schoolUsers
      let savedSchoolData = this.createdSchoolDetails.find(x=>x.schoolName == school.schoolName && x.id == school.id);
      school = savedSchoolData!;
      school.schoolId = savedSchoolData!.schoolId;

      if(school.numberOfSchoolUser == 1){
        this.toasterService.error(`Maximum number of school users for ${school.schoolName} has already been created`);
        return;
      }

      if (school.numberOfSchoolUser!-1 < schoolUsersList.length) {
        this.toasterService.error(`Maximum number of school users for ${school.schoolName} that could be created is ${school.numberOfSchoolUser}`);
        return;
      }

      try {
        //Check if subscription is available for each school's school user
        let numberOfSubscriptionAvailable = await this.packageService.getAvailableSubscriptionForPackage(this.packageToAssign);
        if(numberOfSubscriptionAvailable < schoolUsersList.filter(user => user.schoolUserId == 0 || user.schoolUserId == undefined || user.schoolUserId == null).length) {
          this.toasterService.error("Package has exceeded the maximum number of subscriptions");
          return;
        }
      }
      catch (errorResponse: any) {
        this.toasterService.error(errorResponse.error, 'Error');
        return;
      }

      school.id = this.createdSchoolDetails[i].id;
      school.schoolUsers = [];
      for(const element of schoolUsersList) {
        let schoolUser: DtoSchoolUser = element;
        schoolUser.countryCode = this.phoneNumberUtil.parse(schoolUser.contactNumber?.toString()).getCountryCode()!;
        schoolUser.phoneNumber = this.phoneNumberUtil.parse(schoolUser.contactNumber?.toString()).getNationalNumber()!;
        schoolUser.schoolUserId = schoolUser.schoolUserId ?? 0;
        schoolUser.schoolId = schoolUser.schoolId ?? 0;
        if(!schoolUser.role.length){
          this.toasterService.warning("Please select at least one role to create a user");
          return;
        }
        school.schoolUsers.push(schoolUser);
      }
      schoolData.push(school);
    }

    this.schoolService.createSchoolUsers(schoolData).subscribe((response: any) => {
      if (response.isSuccess) {
        schoolData.forEach((school: DtoSchool) => {
          // Get school users for the current school
          this.schoolService.getSchoolUsers(school.schoolUsers[0].emailId!, school.schoolId!).subscribe(
            (schoolUserResponse: DtoSchoolUser[] | any) => {
              const schoolUserList = schoolUserResponse;
              schoolUserList.forEach((schooluser: DtoSchoolUser) => {
                // Find the matching school account files by school name
                const matchingSchoolUserFiles = Object.values(this.schoolUserUploadedFileLists).find(
                    item => item.id === schooluser.emailId
                );
    
                if (matchingSchoolUserFiles && matchingSchoolUserFiles.files.length > 0) {
                  const formData = new FormData();
                  matchingSchoolUserFiles.files.forEach((file) => {
                      formData.append('file', file, file.name);
                  });
                  this.uploadDocument(formData, DocumentType.EntityAudience, schooluser.userId.toString());
                }
              });
            },
            (err: HttpErrorResponse) => {
              if(err.error){
                this.toasterService.error(err.error, "Error");
              }
            }
          );
        });
        this.getIndependentSchools(this.pagination);
        this.toasterService.success('Individual School created successfully!', 'Success');
      }
    }, (errorResponse: HttpErrorResponse) => {
      if(errorResponse.error){
        this.toasterService.error(errorResponse.error, "Error");
      }
    })
  }

  hasDuplicates(valuesToCheck: string[]) {
    if(!valuesToCheck){
      return false;
    }
    let mySet = new Set(valuesToCheck);
    if (mySet.size !== valuesToCheck.length) {
      return true;
    }
    else {
      return false;
    }  
  }

  uploadDocument(formData: FormData, documentTypeId: string, referenceId: string) {
    this.matAccountService.uploadDocument(formData, documentTypeId, referenceId).subscribe(
      (res: any) => {
        if (res) {
          console.log("Uploaded Successfully");
        }
      },
      (error: HttpErrorResponse) => {
        if(error.error){
          this.toasterService.error(error.error, "Error");
        }
      }
    );
  }
  uploadFromLocal(event: Event, triggeredManually = false): void {
    if (!triggeredManually) {
      event.preventDefault();
      this.sharedService.setUploadedFile(this.schoolUploadFileList);
      this.dialog.open(ConfirmDialogComponent, { width: '675px' });
    }
    if (this.fileInput) {
      this.fileInput.nativeElement.click();
    }
  }

  actionTriggered(data: any): void {
    if (data.action === Mode.Edit) {
      this.isEdit = true;
      this.schoolService.getSchool(data.schoolId).subscribe((response: DtoSchool) => {
        if (response) {
          this.schoolToEdit = response;
          this.createIndividualSchoolForm = true;
          this.currentStep = this.steps.AssignPackage;
          this.maxStep = this.currentStep > this.maxStep ? this.currentStep : this.maxStep;
          this.sharedService.setUploadedFile(data.document);
          this.schoolUploadFileList = data.document;
        }
      },(err: HttpErrorResponse)=>{
        if(err.error){
          this.toasterService.error(err.error, "Error");
        }
      })
    }
    else if(data.action === Mode.CreateIndividualSchool){
      this.createIndividualSchoolForm = true;
      this.currentStep = this.steps.AssignPackage;
      this.maxStep = this.currentStep > this.maxStep ? this.currentStep : this.maxStep;
      this.schoolUploadFileList = []
    }
    else if (data.action === Mode.Delete) {
      this.dialog.open(ConfirmComponent, {
        width: '375px',
        data: {
          status: true,
          message: "Are you sure want to delete the school?"
        }
      }).afterClosed().subscribe((popupEvent: any) => {
        if (popupEvent?.event == MatDialogCloseEvent.SUCCESS) {
          this.schoolService.deleteSchool(data.schoolId).subscribe((res) => {
            if (res) {
              this.toasterService.success("School deleted successfully!", "Success");
              this.getIndependentSchools(this.pagination);
            }
          }, (error: HttpErrorResponse) => {
            if(error.error){
              this.toasterService.error(error.error, "Error");
            }
          })
        }
      });
    }
    else { //Mode.Preview
      this.schoolUploadFileList = data.document;
      this.sharedService.setUploadedFile(this.schoolUploadFileList);
      this.dialog.open(ConfirmDialogComponent, { width: '675px', data: true });
    }
  }

  onFileSelected(event: any) {
    if (!this.schoolUploadFileList) {
      this.schoolUploadFileList = [];
    }

    let filesExist = event.target.files.length;
    if (filesExist > 0) {
      for (let i = 0; i < filesExist; i++) {
        if (event.target.files && event.target.files[i]) {
          let _object: File = event.target.files[i];

          this.schoolUploadFileList.push(_object);
        }
      }
      this.sharedService.changeUploadingStatus(false);
      this.sharedService.setUploadedFile(this.schoolUploadFileList);
      this.fileInput!.nativeElement.value = null;
    }
  }

  cancel() {
    if (this.dialogRef) {
      this.dialogRef.close({ event: MatDialogCloseEvent.SUCCESS });
    } else {
      console.log('Not opened as a dialog, no need to close');
    }
  }

  navigateToUserCenter() {
    this.router.navigate(['/userCenter']);
  }

  resetSchoolForm() {
    // Reset the form values
    this.schoolDetailsForm.reset();
  
    // Clear the FormArray 'schools'
    const schoolsDetailsArray = this.schoolDetailsForm.get('schools') as FormArray;
    while (schoolsDetailsArray && schoolsDetailsArray.length !== 0) {
      schoolsDetailsArray.removeAt(0); // Remove all controls one by one
    }
    this.sharedService.updateSchoolFormValidity(this.schoolDetailsForm);
  }

  resetRoleForm() {
    // Reset the form values
    this.roleForm.reset();
  
    // Clear the FormArray 'roleDetails'
    const roleDetailsArray = this.roleForm.get('roleDetails') as FormArray;
    while (roleDetailsArray && roleDetailsArray.length !== 0) {
      roleDetailsArray.removeAt(0); // Remove all controls one by one
    }
    this.sharedService.updateRoleFormValidity(this.roleForm);
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
    if (this.schoolFormSubscription) {
      this.schoolFormSubscription.unsubscribe();
    }
  }
  sendBulkEmail(){
    this.dialog.open(SendBulkEmailComponent,{width:'1000px',
    panelClass: 'modal-prodetails',
    data: { isForMatAccounts: false }})
  }
}

export enum Steps {
  AssignPackage = 1,
  CreatePackage = 2,
  EditPackage = 3,
  AddSchool = 4,
  CreateRole = 5,
  CreateUser = 6
}